import React from 'react';
import '../../assets/css/PropertyCard.css';

const PropertyCard = ({ property }) => {
  if (!property) {
    console.error('Property is undefined or null');
    return <div style={{color: 'red'}}>DEBUG: Property is null</div>;
  }

  // Get featured image URL with multiple fallbacks
  let featuredImage = null;
  
  if (property.fimg_url) {
    featuredImage = property.fimg_url;
  } else if (property._embedded?.['wp:featuredmedia']?.[0]?.source_url) {
    featuredImage = property._embedded['wp:featuredmedia'][0].source_url;
  } else if (property.featured_image) {
    featuredImage = property.featured_image;
  }

  const { 
    title,
    acf,
    link
  } = property;

  const address = acf?.address;
  const price = acf?.price;
  const pricingAlternative = acf?.pricing_alternative;


  return (
    <a 
      href={link}
      className="property-card" 
      style={{
        display: 'block',
        textDecoration: 'none',
        color: 'inherit',
        borderRadius: '8px',
        overflow: 'hidden',
        backgroundColor: '#fff',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}
    >
      <div className="property-image-container">
        {featuredImage ? (
          <img 
            src={featuredImage}
            alt={title?.rendered || 'Property'} 
            className="property-image"
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
        ) : (
          <div className="property-image-placeholder">
            No Image Available
          </div>
        )}
      </div>
      <div style={{ padding: '1rem' }}>
        <h3 style={{ margin: '0 0 0.5rem' }}>
          {title?.rendered || 'Untitled Property'}
        </h3>
        {address && (
          <p style={{ margin: '0 0 0.5rem', color: '#666' }}>
            {`${address.street || ''}, ${address.city || ''}, ${address.state || ''} ${address.zip_code || ''}`}
          </p>
        )}
        {(price || pricingAlternative) && (
          <p style={{ margin: '0', fontSize: '1.25rem', fontWeight: 'bold' }}>
            {price ? `$${Number(price).toLocaleString()}` : pricingAlternative}
          </p>
        )}
      </div>
    </a>
  );
};

export default PropertyCard;